<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">All Budget</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-plus" label="Add Budget" iconPos="left"></button>
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" [autoLayout]="true"  responsiveLayout="scroll" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Code<p-sortIcon field="code"></p-sortIcon></th>
            <th>Name</th>
            <th>Category</th>
            <th>Quantity</th>
            <th>Status</th>
            <th>Progress</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>{{product.code}}</td>
            <td>{{product.name}}</td>
            <td>{{product.category}}</td>
            <td>{{product.quantity}}</td>
            <td>
                <p-tag styleClass="me-2 mb-1" value="Primary"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="success" value="Success"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="warning" value="Warning"></p-tag>
                <p-tag severity="danger" value="Danger"></p-tag>
            </td>
            <td>
                <div class="d-flex flex-column justify-content-end">
                    <div class="d-flex justify-content-end mb-1">
                        <small>10/10 Steps</small>
                    </div>
                    <p-progressBar [value]="10"></p-progressBar>
                </div>
            </td>
            <td>
                <button pButton pRipple type="button" icon="pi pi-check" class="p-button-text"></button>
                <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-success p-button-text"></button>
                <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-danger p-button-text"></button>
            </td>
        </tr>
    </ng-template>
</p-table>
</div>

